import { StylesIndexInjections } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';

export default makeUiStyles((theme: Theme) => createStyles({
  rangeRadiosLabel: {
    marginBottom: 8,
  },
  datepickerBoxWrapper: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  datepickerBox: {
    display: 'flex',
    alignItems: 'flex-end',
    '& > div': {
      width: 156,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    '& > div:not(:last-child)': {
      marginRight: 20,
      [theme.breakpoints.down('xs')]: {
        marginRight: 0,
      },
    },
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      gap: 8,
      '& .MuiTextField-root': {
        width: '100%',
      },
    },
  },
  datePicker: {
    paddingTop: 6,
    paddingBottom: 3,
    paddingLeft: 20,
    '& input': {
      position: 'relative',
      top: -1,
    },
  },
  datePickerErrorMessage: {
    position: 'absolute',
  },
}), { name: 'ChartDateRangeControls', index: StylesIndexInjections.OTHER });
